<template lang="pug">
AppToggleDropdownItem(
  :disabled="disabled"
  :active="active"
  :has-submenu="hasSubmenu"
  @click="onClick"
)
  slot
</template>

<script>
/**
 *  AppColumnsToggle emits `@change` with `{key: value }`
 */

export default {
  name: 'AppColumnToggle',
  inject: {
    onTableColToggled: { default: () => {} },
  },
  props: {
    column: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    hasSubmenu: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change'],
  methods: {
    onClick() {
      if (!this.disabled) {
        const payload = { [this.column]: !this.active };

        this.$emit('change', payload);
        this.onTableColToggled({ col: this.column, on: !this.active });
      }
    },
  },
};
</script>
